import React, { useEffect, useState } from "react";
import classNames from "classnames";

let showToastFunction = null;

const ToastNotification = () => {
  const [message, setMessage] = useState(null);
  const [visible, setVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    showToastFunction = (newMessage, duration = 2000) => {
      // Clear any existing timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      setMessage(newMessage);
      setVisible(true);

      // Set a new timeout
      const newTimeout = setTimeout(() => {
        setVisible(false);
        setTimeout(() => setMessage(null), 300); // Ensure fade-out completes
      }, duration);

      setTimeoutId(newTimeout);
    };

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  // Dismiss function for manual close
  const dismissToast = () => {
    setVisible(false);
    setTimeout(() => setMessage(null), 300);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };

  if (!message) return null;

  return (
    <div className={classNames(
      "fixed bottom-6 left-1/2 -translate-x-1/2 flex items-center justify-between",
      "bg-[var(--color-gray-800)] text-[var(--color-white)] text-p-reg font-outfit px-6 py-3 rounded-lg shadow-light",
      "transition-opacity duration-300 z-[1100]",
      visible ? "opacity-100" : "opacity-0"
    )}>
      <span>{message}</span>

      {/* Dismiss Button */}
      <button 
        onClick={dismissToast}
        className="ml-4 px-4 py-1 border border-white text-[var(--color-white)] rounded-md hover:bg-[var(--color-white)] hover:text-[var(--color-gray-800)] transition"
      >
        Dismiss
      </button>
    </div>
  );
};

// Global function to trigger a toast
export const toastManager = {
  addToast: (message, duration = 2000) => {
    if (showToastFunction) {
      showToastFunction(message, duration);
    } else {
      console.warn("ToastNotification is not yet mounted");
    }
  },
};

export default ToastNotification;
